function objectToParams(obj) {
  return Object.keys(obj)
    .map(key => key + '=' + obj[key])
    .join('&')
}

export default objectToParams
